<div class="filter-textbox">
  <input
    type="text"
    (keyup)="filterDefects()"
    [(ngModel)]="filterString"
    placeholder="{{ 'input_app_multi_select.inputPlaceholder' | translate }}"
  />
  <i class="zf-icon zf-icon-search zf-icon-s"></i>
</div>

<ng-container>
  <!-- <monorepo-issue-category-filter
    [selectedCategory]="category"
    [categoriesToShow]="categoriesToShow"
    (changeCategory)="filterListByCategory($event)"
  ></monorepo-issue-category-filter> -->
</ng-container>

<ion-row class="m-multi-select">
  <ion-col sizeLg="4" sizeMd="6" size="12" class="ion-no-padding" *ngFor="let item of filteredList; trackBy: trackByFn">
    <ion-card
      (click)="onSelect(item.data.issueId)"
      class="m-multi-select__item"
      [ngClass]="{ 'm-multi-select__item--selected': item.selected }"
      style="max-height: 100px"
    >
      <ion-card-header>
        <ion-card-title class="card-title" [ngClass]="{ 'card-title--selected': item.selected }">
          <div class="card-title__issue-name">
            {{ item.data.issueName }}
          </div>
        </ion-card-title>
      </ion-card-header>
    </ion-card>
  </ion-col>
</ion-row>
<div *ngIf="!filteredList.length" class="m-multi-select__default-error">
  {{ 'input_app_multi_select.noItemsAvailable' | translate }}
</div>
